/**
 * created by lei lei
 * 微信预览
 *  //页面引入组件，下面写法
 *   <WeChatReview ref={(WeChatReview)=>{this.WeChatReview=WeChatReview}}/>
 *   //预览方法
 *   *  this.WeChatReview.show(materialId,viewStuffId)
 *  materialId,viewStuffId  微信预览的两个必须参数
 *  signWords 打标记用的选填
 *
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Button, Modal} from "antd";
import * as Utils from "../../../utils";
import ContentModal from "../../../containers/contentModal";
import {Scrollbars} from "react-custom-scrollbars";

export default class WeChatReview extends Component {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            weChatStatus: false,
            materialId: '',
            viewStuffId: '',
            signWords: [],
            params: {},
            title : '',
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    render() {
        return (
            <div>
                <Modal key={Utils.uuid()} title={"内容详情"} visible={this.state.weChatStatus} bodyStyle={{height: !this.state.params.showContent ? "75vh" : "40vh"}}
                       onCancel={() => {
                           this.setState({weChatStatus: false})
                       }} footer={
                    this.state.params.url ?
                        <Button type="primary" onClick={() => {
                            window.open(this.state.params.url)
                        }}> 查看原公众号</Button> : null
                }>
                    {!this.state.params.showContent ?
                        <ContentModal materialId={this.state.materialId} viewStuffId={this.state.viewStuffId}
                                      signWords={this.state.signWords}  {...this.state.params} />
                        :
                        <Scrollbars>
                            <div style={{padding: "15px"}}>
                                <span>{this.state.params.updateDate}</span>
                                <div dangerouslySetInnerHTML={{__html: this.state.title}}></div>
                            </div>
                        </Scrollbars>
                    }
                </Modal>
            </div>
        )
    }

    show(materialId, viewStuffId, signWords = [],params) {
        let title;
        if (signWords && signWords.length > 0) {
            title = Utils.filtion(signWords, "<div>" + params.title + "</div>").value;
        }else{
            title ="<div>" + params.title + "</div>";
        }
        this.setState({
            weChatStatus: true,
            materialId: materialId,
            viewStuffId: viewStuffId,
            signWords: signWords,
            params:params,
            title
        })
    }

}